import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { useTitle } from "../../hooks/useTitle";

export default function AdminLogin() {
  useTitle("Admin Login");
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate("/admin", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full px-4 py-3 rounded-lg bg-[#111827] border border-[#1F2937] text-sm text-[#F9FAFB] placeholder:text-[#6B7280] focus:outline-none focus:ring-2 focus:ring-[#10B981]/40 focus:border-[#10B981] transition";

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#080C14] border border-[#1F2937] rounded-2xl p-8 space-y-5" data-testid="admin-login-form">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 bg-[#0A192F] rounded-lg flex items-center justify-center border border-[#C59B27]/70">
            <span className="text-[#C59B27] font-display font-extrabold text-sm">SN</span>
          </div>
          <div>
            <p className="font-display font-extrabold text-[#F9FAFB]">SterlingNest Admin</p>
            <p className="text-[10px] font-mono-sn text-[#9CA3AF] tracking-widest">CMS · CRM · LEADS</p>
          </div>
        </div>
        <div>
          <label className="block text-xs font-semibold text-[#9CA3AF] mb-1.5">Email</label>
          <input data-testid="admin-email-input" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@sterlingnest.in" />
        </div>
        <div>
          <label className="block text-xs font-semibold text-[#9CA3AF] mb-1.5">Password</label>
          <input data-testid="admin-password-input" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-btn"
          className="w-full py-3 rounded-lg bg-[#10B981] text-[#0B0F19] font-display font-bold text-sm hover:bg-[#0ea371] transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
